import axiosInstance from '../axiosInstance';

const get = async () => {
  return axiosInstance.get('/game').then((response) => {
    return response.data;
  });
};

const getById = async (gameId) => {
  return axiosInstance.get(`/game/${gameId}`).then((response) => {
    return response.data;
  });
};

const getByEventId = async (eventId, options = {}) => {
  const { includePhotos = true } = options;
  const url =
    includePhotos === false ? `/game/event/${eventId}?includePhotos=false` : `/game/event/${eventId}`;

  return axiosInstance.get(url).then((response) => {
    return response.data;
  });
};

const getBySectionId = async (sectionId) => {
  return axiosInstance.get(`/game/section/${sectionId}`).then((response) => {
    return response.data;
  });
};

const getByUserId = async () => {
  return axiosInstance.get('/game/user').then((response) => {
    return response.data;
  });
};

const getOverviewByUserId = async () => {
  return axiosInstance.get('/game/user/overview').then((response) => {
    return response.data;
  });
};

const getByScorer = async () => {
  return axiosInstance.get('/game/scorer').then((response) => {
    return response.data;
  });
};

const create = async (game) => {
  return axiosInstance.post('/game', game).then((response) => {
    return response.data;
  });
};

const update = async (gameId, game) => {
  return axiosInstance.put(`/game/${gameId}`, game).then((response) => {
    return response.data;
  });
};

const remove = async (gameId) => {
  return axiosInstance.delete(`/game/${gameId}`).then((response) => {
    return response.data;
  });
};

const resetGame = async (gameId) => {
  return axiosInstance.put(`/game/${gameId}/reset`).then((response) => {
    return response.data;
  });
};

const mockResult = async (gameId) => {
  return axiosInstance.put(`/game/${gameId}/mock-result`).then((response) => {
    return response.data;
  });
};

const mockRoundResults = async (data) => {
  return axiosInstance
    .put(`/game/mock-round/${data.eventId}/${data.sectionId}`, { round: data.round })
    .then((response) => {
      return response.data;
    });
};

const resetRoundGames = async (data) => {
  return axiosInstance
    .put(`/game/reset-round/${data.eventId}/${data.sectionId}`, { round: data.round })
    .then((response) => {
      return response.data;
    });
};

const startGame = async (data) => {
  return axiosInstance.put(`/game/start/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

const scoreGame = async (data) => {
  return axiosInstance.put(`/game/score/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

const undoLastScore = async (gameId) => {
  return axiosInstance.put(`/game/undo/${gameId}`).then((response) => {
    return response.data;
  });
};

const startNewSet = async (gameId) => {
  return axiosInstance.put(`/game/newSet/${gameId}`).then((response) => {
    return response.data;
  });
};

const startPlayoff = async (gameId) => {
  return axiosInstance.put(`/game/playoff/start/${gameId}`).then((response) => {
    return response.data;
  });
};

const scorePlayoffGame = async (data) => {
  return axiosInstance.put(`/game/playoff/score/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

const undoPlayoffScore = async (gameId) => {
  return axiosInstance.put(`/game/playoff/undo/${gameId}`).then((response) => {
    return response.data;
  });
};

const inputSetScore = async (data) => {
  return axiosInstance.put(`/game/inputSetScore/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

const publicStartGame = async (data) => {
  return axiosInstance.put(`/game/public/start/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

const publicScoreGame = async (data) => {
  return axiosInstance.put(`/game/public/score/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

const publicUndoLastScore = async (gameId) => {
  return axiosInstance.put(`/game/public/undo/${gameId}`).then((response) => {
    return response.data;
  });
};

const publicNewSet = async (gameId) => {
  return axiosInstance.put(`/game/public/newSet/${gameId}`).then((response) => {
    return response.data;
  });
};

const assignScorer = async (data) => {
  return axiosInstance.put(`/game/assignScorer/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

const assignMySelf = async (data) => {
  return axiosInstance.put(`/game/assignMySelf/${data.gameId}`).then((response) => {
    return response.data;
  });
};

const removeScorer = async (data) => {
  return axiosInstance.put(`/game/removeScorer/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

const saveScorecardPhoto = async (data) => {
  return axiosInstance.put(`/game/saveScorecardPhoto/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

// const generateGames12LogBased = async (data) => {
//   return axiosInstance.post('/game/generateGames12LogBased', data).then((response) => {
//     return response.data;
//   });
// };

const generateGames = async (data) => {
  return axiosInstance
    .post(`/game/generate-games/${data.eventId}/${data.sectionId}`, data)
    .then((response) => {
      return response.data;
    });
};

const updateGameGreenRink = async (data) => {
  return axiosInstance.put(`/game/updateGreenRink/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

const updateTotalPoints = async (data) => {
  return axiosInstance.put(`/game/updateTeamTotalPoints/${data.gameId}`, data).then((response) => {
    return response.data;
  });
};

const getQuickGames = async () => {
  return axiosInstance.get('/game/quick').then((response) => {
    return response.data;
  });
};

const gameService = {
  get,
  getById,
  getByEventId,
  getBySectionId,
  getByUserId,
  getOverviewByUserId,
  getByScorer,
  create,
  update,
  remove,
  resetGame,
  mockResult,
  mockRoundResults,
  resetRoundGames,
  startGame,
  scoreGame,
  undoLastScore,
  startNewSet,
  startPlayoff,
  scorePlayoffGame,
  undoPlayoffScore,
  inputSetScore,
  assignScorer,
  assignMySelf,
  removeScorer,
  saveScorecardPhoto,
  // generateGames12LogBased,
  generateGames,
  publicStartGame,
  publicScoreGame,
  publicUndoLastScore,
  publicNewSet,
  updateGameGreenRink,
  updateTotalPoints,
  getQuickGames
};

export default gameService;
